/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { KnowledgeGuideDetail } from '../models/KnowledgeGuideDetail';
import type { KnowledgeGuideListResponse } from '../models/KnowledgeGuideListResponse';
import type { KnowledgeNavMenuResponse } from '../models/KnowledgeNavMenuResponse';
import type { ServiceNowKnowledgeListResponse } from '../models/ServiceNowKnowledgeListResponse';
import type { ServiceNowKnowledgePageDetail } from '../models/ServiceNowKnowledgePageDetail';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class KnowledgeService {

    /**
     * Get Nav Menu
     * @returns KnowledgeNavMenuResponse Successful Response
     * @throws ApiError
     */
    public static getNavMenuApiV1KnowledgeNavMenuGet(): CancelablePromise<KnowledgeNavMenuResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/knowledge/nav-menu',
        });
    }

    /**
     * Get Servicenow Pages
     * @param categorySlug
     * @returns ServiceNowKnowledgeListResponse Successful Response
     * @throws ApiError
     */
    public static getServicenowPagesApiV1KnowledgeServicenowPagesGet(
        categorySlug?: (string | null),
    ): CancelablePromise<ServiceNowKnowledgeListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/knowledge/servicenow/pages',
            query: {
                'category_slug': categorySlug,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Servicenow Page
     * @param id
     * @returns ServiceNowKnowledgePageDetail Successful Response
     * @throws ApiError
     */
    public static getServicenowPageApiV1KnowledgeServicenowPagesIdGet(
        id: string,
    ): CancelablePromise<ServiceNowKnowledgePageDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/knowledge/servicenow/pages/{id}',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Log Servicenow Page View
     * Report an in-app article view to ServiceNow's Knowledge Use table.
     *
     * Deliberately separate from ``GET /servicenow/pages/{id}`` so client-side
     * cache refetches of the same article don't inflate ServiceNow view counts;
     * the frontend calls this once per article a reader opens. The ServiceNow
     * write runs in the background because the reader already has the article.
     * Restricted article ids must pass the same live ServiceNow ACL checks as
     * their content before that write can be queued.
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static logServicenowPageViewApiV1KnowledgeServicenowPagesIdViewPost(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/knowledge/servicenow/pages/{id}/view',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Servicenow Image
     * Authorization-aware proxy for ServiceNow KB attachment images.
     *
     * KB article body_html is rewritten (see
     * helpers.servicenow_image_proxy.rewrite_servicenow_attachment_srcs) to
     * point image srcs here instead of directly at ServiceNow, since the
     * browser has no ServiceNow session to satisfy those requests. Public
     * article attachments retain the shared cached service-account path.
     * Restricted attachments require a live ServiceNow authorization decision
     * for the current employee, and their bytes are fetched with that
     * employee's JWT without using the shared cache.
     * @param sysId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getServicenowImageApiV1KnowledgeServicenowImageSysIdGet(
        sysId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/knowledge/servicenow-image/{sys_id}',
            path: {
                'sys_id': sysId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Knowledge Guides
     * @returns KnowledgeGuideListResponse Successful Response
     * @throws ApiError
     */
    public static listKnowledgeGuidesApiV1KnowledgeGuidesGet(): CancelablePromise<KnowledgeGuideListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/knowledge/guides',
        });
    }

    /**
     * Get Knowledge Guide
     * @param guideId
     * @returns KnowledgeGuideDetail Successful Response
     * @throws ApiError
     */
    public static getKnowledgeGuideApiV1KnowledgeGuidesGuideIdGet(
        guideId: string,
    ): CancelablePromise<KnowledgeGuideDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/knowledge/guides/{guide_id}',
            path: {
                'guide_id': guideId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
